// Importar los tipos de acciones
import { GET_CLIENTES_USUARIO,LOGIN_USUARIO,LOGOUT_USUARIO,
  GET_SERVICIOS_TO_CLIENT,GET_TAREAS_TO_SERVICIO,CLEAR_HORAS,DATO_USUARIO,
  START_LOADING_SERVICIOS, FINISH_LOADING_SERVICIOS,START_LOADING_CLIENTES,FINISH_LOADING_CLIENTES,
  START_LOADING_TAREAS,LIMPIAR_HORAS,SET_USUARIOS,SET_HORAS_REPORTE,LOGIN_ERROR,GET_TODOS_CLIENTES,
  FINISH_LOADING_TAREAS,LIMPIAR_SERVICIOS,LIMPIAR_TAREAS,ACTUALIZAR_ESTADO_TARJETAS,GET_TODAS_AREAS,OBTENER_ESTADO_HORAS_HABILITADAS,
  CARGAR_HORAS, CARGAR_HORAS_EXITO, CARGAR_HORAS_ERROR, ACTUALIZAR_HORAS,OBTENER_HORAS,HABILITAR_HORAS,
  CARGAR_HORAS_USUARIO,ACTUALIZAR_HORAS_USUARIO_LOGIN,ELIMINAR_HORAS,GET_TAREAS_DEFAULT,SET_TAREAS_DEFAULT, GET_TODAS_TAREAS,GET_SERVICIOS_TO_AREA_CLIENT,
  // Importar los nuevos action types para mis horas
  GET_MIS_HORAS_MES_ACTUAL, GET_MIS_HORAS_POR_CLIENTE, GET_MIS_HORAS_POR_SEMANA, 
  GET_MIS_HORAS_POR_FECHA, GET_MIS_HORAS_RESUMEN, LOADING_MIS_HORAS, ERROR_MIS_HORAS, CLEAR_MIS_HORAS,
  // Importar los nuevos action types para reporte de usuario
  GET_HORAS_REPORTE_USUARIO, GET_HORAS_REPORTE_TODOS_USUARIOS, LOADING_REPORTE_USUARIO, 
  ERROR_REPORTE_USUARIO, CLEAR_REPORTE_USUARIO,
  // Importar los nuevos action types para reporte de clientes
  GET_HORAS_REPORTE_CLIENTE, GET_HORAS_REPORTE_TODOS_CLIENTES, LOADING_REPORTE_CLIENTE,
  ERROR_REPORTE_CLIENTE, CLEAR_REPORTE_CLIENTE,
  // Importar los nuevos action types para reporte de área
  GET_HORAS_REPORTE_AREA, LOADING_REPORTE_AREA, ERROR_REPORTE_AREA, CLEAR_REPORTE_AREA
} from '../actions/actionstypes';


// Definir el estado inicial
const initialState = {
    // Propiedades iniciales del estado
    
    clientes: [],
    servicios: [],
    tareas : [],
    tareasToservicio: [],
    serviciosPorArea: [],
    horas: [],
    horasReporte: [],
    session: {
        token: localStorage.getItem('token'),
        id: null, // Agrega esto
        perfil: null, //
        // otras propiedades de la sesión
      },
      usuario: {},
      horasHabilitadas: null,
      usuariosHorasHabilitadas: [],
      // clientesCargando eliminado - no se usa
      serviciosCargando: false,
      tareasCargando:false,
      // loading, error, data eliminados - no se usan
     tareasDefault: [],
     usuarios: [],
     clientesReporte: [],
     Repoteareas: [],
     auth: {
      error: null,
  },
  // Estado para mis horas del usuario logueado
  misHoras: {
    horas: [],
    loading: false,
    error: null,
    totalHoras: 0,
    filtrosActivos: {},
    tipoConsulta: null // 'mes-actual', 'por-cliente', 'por-semana', 'por-fecha', 'resumen'
  },
  
  // Estado para reporte de usuario
  reporteUsuario: {
    horas: [],
    loading: false,
    error: null,
    tipoConsulta: null // 'usuario-especifico', 'todos-usuarios'
  },
  
  // Estado para reporte de clientes
  reporteCliente: {
    horas: [],
    loading: false,
    error: null,
    tipoConsulta: null // 'cliente-especifico', 'todos-clientes'
  },
  
  // Estado para reporte de área
  reporteArea: {
    horasConsultadas: [],
    loading: false,
    error: null,
    tipoConsulta: null // 'area-especifica', 'usuario-especifico', 'general'
  },
 

    

   

};

// Definir el reducer
const reducer = (state = initialState, action) => {
    switch (action.type) {
        case GET_CLIENTES_USUARIO:
            return {
                ...state,
                clientes: action.payload, // Aquí actualizamos el estado clientes con los datos que vienen en action.payload
            };
        case GET_TODOS_CLIENTES:
          return{
            ...state,
            clientesReporte: action.payload
          };
          case GET_TODAS_AREAS:
            return{
              ...state,
              Repoteareas: action.payload
            };

         case GET_SERVICIOS_TO_CLIENT:
              return {
                ...state,
                servicios: action.payload
         };
         case GET_SERVICIOS_TO_AREA_CLIENT:
          return{
            ...state,
            serviciosPorArea: action.payload
          };
         case GET_TAREAS_TO_SERVICIO:
                return {
                  ...state,
                  tareasToservicio: action.payload
      };
      case HABILITAR_HORAS: {
        const usuarioIds = action.payload?.usuarioIds || [];
        const usuarioActualId = state.session?.id;
        const habilitadaParaUsuario = usuarioIds.length === 0 ? false : usuarioIds.includes(usuarioActualId);
        
        return {
            ...state,
            horasHabilitadas: habilitadaParaUsuario,
            usuariosHorasHabilitadas: usuarioIds,
        };
      }
      case OBTENER_ESTADO_HORAS_HABILITADAS: {
        const usuarioIds = action.payload?.usuarioIds || [];
        const usuarioActualId = state.session?.id;
        const habilitadaParaUsuario = usuarioIds.length === 0 ? false : usuarioIds.includes(usuarioActualId);
        
        return {
            ...state,
            horasHabilitadas: habilitadaParaUsuario,
            usuariosHorasHabilitadas: usuarioIds,
        };
      }

         case LOGIN_USUARIO:
                return {
                    ...state,
                    session: {
                      ...state.session,
                      token: action.payload,
                      id: action.payload.id,
                      perfil: action.payload.perfil
                    }
                };
                case DATO_USUARIO:  
                   return {  
               ...state,
                   usuario: action.payload.usuario
                    };
                case LOGIN_ERROR:
                  return {
                    ...state,
                    auth: {
                      ...state.auth,
                      error: action.payload,
                    },
                  };
                  case LOGOUT_USUARIO:
                    const horasHabilitadas = state.horasHabilitadas; // Guarda el valor actual de horasHabilitadas
                    const usuariosHorasHabilitadas = state.usuariosHorasHabilitadas;
                    return {
                      ...initialState,
                      horasHabilitadas, // Asigna el valor guardado a horasHabilitadas
                      usuariosHorasHabilitadas,
                      session: {
                        ...initialState.session,
                        token: null
                      }
                    };
         case START_LOADING_SERVICIOS:
                      return {
                        ...state,
                        serviciosCargando: true,
                      };
                
          case FINISH_LOADING_SERVICIOS:
                      return {
                        ...state,
                        serviciosCargando: false,
                      };

         case START_LOADING_CLIENTES:
                        return {
                            ...state,
            // clientesCargando removido - no se utiliza
                        };
                    
          case FINISH_LOADING_CLIENTES:
                        return {
                            ...state,
            // clientesCargando removido - no se utiliza
                        };
          case START_LOADING_TAREAS:
                          return {
                              ...state,
                              tareasCargando: true,
                          };
                      
          case FINISH_LOADING_TAREAS:
                          return {
                              ...state,
                              tareasCargando: false,
                          };
          case LIMPIAR_SERVICIOS:
                            return {
                              ...state,
                              servicios: [], // limpia los servicios
                            };
          case LIMPIAR_TAREAS:
                              return {
                                ...state,
                                tareas: [], // limpia los servicios
                              };
          case CARGAR_HORAS:
            return { ...state, loading: true, error: null };

            case CARGAR_HORAS_EXITO:
              const nuevasHoras = {
                ...state.horas,
                [action.payload.cardId]: [...(state.horas[action.payload.cardId] || []), action.payload],
              };
              
              return {
                ...state,
                loading: false,
                horas: nuevasHoras,
              };
              case CARGAR_HORAS_USUARIO:
                return {
                  ...state,
                  horas: {
                   
                    ...action.payload
                  }
                };

          case CARGAR_HORAS_ERROR:
                                return { ...state, loading: false, error: action.payload };                      
                                
                                case ACTUALIZAR_HORAS:
                                  return {
                                      ...state,
                                      horas: {
                                          ...state.horas,
                                          [action.payload.id]: action.payload
                                      }
                                  }; 
                                  case ACTUALIZAR_HORAS_USUARIO_LOGIN:
                                    return {
                                      ...state,
                                      horas: {
                                        ...state.horas,
                                        [action.payload.fecha]: action.payload.nuevasHoras,
                                      },
                                    };

                                    case ELIMINAR_HORAS:
                                      const horasActualizadas = { ...state.horas };
                                      delete horasActualizadas[action.payload];
                                      return {
                                        ...state,
                                        horas: horasActualizadas,
                                      };
    case GET_TAREAS_DEFAULT:
      return {
        ...state,
        tareasDefault: action.payload
      };
      case SET_TAREAS_DEFAULT:
        return {
          ...state,
          tareas: state.tareasDefault
        };

    case GET_TODAS_TAREAS:
      return {
        ...state,
        tareas: action.payload,
        loading: false
      };
      case LIMPIAR_HORAS:
  return {
    ...state,
    horas: {}// o cualquier valor inicial que desees para horas
  };
  case ACTUALIZAR_ESTADO_TARJETAS:
    return {
        ...state,
        ...action.payload // Esto asume que payload es un objeto con los nuevos estados
    };
    case OBTENER_HORAS:
      return {
        ...state,
        horas: action.payload,
      };
      case SET_USUARIOS:
        return { ...state, usuarios: action.payload };
        case SET_HORAS_REPORTE:
          return { ...state, horasReporte: action.payload };
        case CLEAR_HORAS:
      return [];
   
   // RESETEAR_HORAS case eliminado - no se utiliza

   // ========== CASOS PARA MIS HORAS DEL USUARIO LOGUEADO ==========
   case LOADING_MIS_HORAS:
     return {
       ...state,
       misHoras: {
         ...state.misHoras,
         loading: true,
         error: null
       }
     };

   case GET_MIS_HORAS_MES_ACTUAL:
     return {
       ...state,
       misHoras: {
         ...state.misHoras,
         horas: action.payload.horas,
         totalHoras: action.payload.totalHoras,
         loading: false,
         error: null,
         tipoConsulta: 'mes-actual',
         filtrosActivos: { mes: action.payload.mes }
       }
     };

   case GET_MIS_HORAS_POR_CLIENTE:
     return {
       ...state,
       misHoras: {
         ...state.misHoras,
         horas: action.payload.horas,
         totalHoras: action.payload.totalHoras,
         loading: false,
         error: null,
         tipoConsulta: 'por-cliente',
         filtrosActivos: { 
           clienteId: action.payload.clienteId,
           periodo: action.payload.periodo
         }
       }
     };

   case GET_MIS_HORAS_POR_SEMANA:
     return {
       ...state,
       misHoras: {
         ...state.misHoras,
         horas: action.payload.horas,
         totalHoras: action.payload.totalHoras,
         loading: false,
         error: null,
         tipoConsulta: 'por-semana',
         filtrosActivos: {
           fechaInicio: action.payload.fechaInicio,
           fechaFin: action.payload.fechaFin,
           totalDias: action.payload.totalDias
         }
       }
     };

   case GET_MIS_HORAS_POR_FECHA:
     return {
       ...state,
       misHoras: {
         ...state.misHoras,
         horas: action.payload.horas,
         totalHoras: action.payload.totalHoras,
         loading: false,
         error: null,
         tipoConsulta: 'por-fecha',
         filtrosActivos: {
           fecha: action.payload.fecha,
           fechaOriginal: action.payload.fechaOriginal
         }
       }
     };

   case GET_MIS_HORAS_RESUMEN:
     return {
       ...state,
       misHoras: {
         ...state.misHoras,
         horas: action.payload.horas,
         totalHoras: action.payload.totalHoras,
         loading: false,
         error: null,
         tipoConsulta: 'resumen',
         filtrosActivos: {
           ...action.payload.filtros,
           fechaDesde: action.payload.fechaDesde,
           fechaHasta: action.payload.fechaHasta,
           mes: action.payload.mes
         }
       }
     };

   case ERROR_MIS_HORAS:
     return {
       ...state,
       misHoras: {
         ...state.misHoras,
         loading: false,
         error: action.payload,
         horas: [],
         totalHoras: 0
       }
     };

   case CLEAR_MIS_HORAS:
     return {
       ...state,
       misHoras: {
         horas: [],
         loading: false,
         error: null,
         totalHoras: 0,
         filtrosActivos: {},
         tipoConsulta: null
       }
     };

   // ========== CASOS PARA REPORTE DE USUARIO ==========
   case LOADING_REPORTE_USUARIO:
     return {
       ...state,
       reporteUsuario: {
         ...state.reporteUsuario,
         loading: true,
         error: null
       }
     };

   case GET_HORAS_REPORTE_USUARIO:
     return {
       ...state,
       reporteUsuario: {
         ...state.reporteUsuario,
         horas: action.payload,
         loading: false,
         error: null,
         tipoConsulta: 'usuario-especifico'
       }
     };

   case GET_HORAS_REPORTE_TODOS_USUARIOS:
     return {
       ...state,
       reporteUsuario: {
         ...state.reporteUsuario,
         horas: action.payload,
         loading: false,
         error: null,
         tipoConsulta: 'todos-usuarios'
       }
     };

   case ERROR_REPORTE_USUARIO:
     return {
       ...state,
       reporteUsuario: {
         ...state.reporteUsuario,
         loading: false,
         error: action.payload,
         horas: []
       }
     };

   case CLEAR_REPORTE_USUARIO:
     return {
       ...state,
       reporteUsuario: {
         horas: [],
         loading: false,
         error: null,
         tipoConsulta: null
       }
     };

   // ========== CASES PARA REPORTE DE CLIENTES ==========
   case LOADING_REPORTE_CLIENTE:
     return {
       ...state,
       reporteCliente: {
         ...state.reporteCliente,
         loading: true,
         error: null
       }
     };

   case GET_HORAS_REPORTE_CLIENTE:
   case GET_HORAS_REPORTE_TODOS_CLIENTES:
     return {
       ...state,
       reporteCliente: {
         ...state.reporteCliente,
         loading: false,
         error: null,
         horas: action.payload,
         tipoConsulta: action.type === GET_HORAS_REPORTE_CLIENTE ? 'cliente-especifico' : 'todos-clientes'
       }
     };

   case ERROR_REPORTE_CLIENTE:
     return {
       ...state,
       reporteCliente: {
         ...state.reporteCliente,
         loading: false,
         error: action.payload,
         horas: []
       }
     };

   case CLEAR_REPORTE_CLIENTE:
     return {
       ...state,
       reporteCliente: {
         horas: [],
         loading: false,
         error: null,
         tipoConsulta: null
       }
     };

   // ========== CASOS PARA REPORTE DE ÁREA ==========
   case LOADING_REPORTE_AREA:
     return {
       ...state,
       reporteArea: {
         ...state.reporteArea,
         loading: true,
         error: null
       }
     };

   case GET_HORAS_REPORTE_AREA:
     return {
       ...state,
       reporteArea: {
         ...state.reporteArea,
         loading: false,
         horasConsultadas: action.payload,
         error: null,
         tipoConsulta: 'area-consulta'
       }
     };

   case ERROR_REPORTE_AREA:
     return {
       ...state,
       reporteArea: {
         ...state.reporteArea,
         loading: false,
         error: action.payload,
         horasConsultadas: []
       }
     };

   case CLEAR_REPORTE_AREA:
     return {
       ...state,
       reporteArea: {
         horasConsultadas: [],
         loading: false,
         error: null,
         tipoConsulta: null
       }
     };

              default:
                return state;
    }
};

 

export default reducer;